import { useRoutes } from 'react-router-dom';

// ----------------------------------------------------------------------

import MainLayout from '../layouts/main/Layout';
import AuthLayout from '../layouts/auth/Layout';
import Layout from '../layouts/base/Layout';

// ----------------------------------------------------------------------

// MAIN
import MainPage from '../pages/main/MainPage';

// AUTH
import LoginPage from '../pages/auth-account/LoginPage';
import PasswordPage from '../pages/auth-account/PasswordPage';
import FindPasswordPage from '../pages/auth-account/FindPasswordPage';
import RestrictPage from '../pages/auth-account/RestrictPage';
import SuccessPage from '../pages/auth-account/SuccessPage';

// ACCOUNT
import LoginLogPage from '../pages/auth-account/LoginLogPage';

// USERS
import RealTimePage from '../pages/users/real-time/RealTimePage';
import AnalysisPage from '../pages/users/AnalysisPage';
import InquiryPage from '../pages/users/inquiry/InquiryPage';
import AlarmPage from '../pages/users/alarm/AlarmPage';
import AlarmSettingPage from '../pages/users/alarm/AlarmSettingPage';

// ADMIN
// 조직
import OrganizationsPage from '../pages/admin/organizations/OrganizationsPage';
import OrganizationsFormPage from '../pages/admin/organizations/FormPage';
// 조직 - IoT 장비 그룹
import OrganizationGroupsPage from '../pages/admin/organization-groups/OrganizationGroupsPage';
// 사용자
import MembersPage from '../pages/admin/members/MembersPage';
import MembersFormPage from '../pages/admin/members/FormPage';
// 로그인 조회
import LoginLogsPage from '../pages/admin/login-logs/LoginLogsPage';
// IoT 장비 현황
import StatusPage from '../pages/admin/status/StatusPage';
// IoT 장비 그룹
import GroupsPage from '../pages/admin/groups/GroupsPage';
import GroupsFormPage from '../pages/admin/groups/FormPage';
// 표시명 관리
import DisplayNamesPage from '../pages/admin/display-names/DisplayNamesPage';
import DisplayNamesFormPage from '../pages/admin/display-names/FormPage';
// IoT 장비
import DevicesPage from '../pages/admin/devices/DevicesPage';
import DevicesFormPage from '../pages/admin/devices/FormPage';
// IoT 장비 - 수질 센서
import SensorsPage from '../pages/admin/sensors/SensorsPage';
// IoT 장비 - 수질 예측측
import PredictionsPage from '../pages/admin/predictions/PredictionsPage';
// 수질 센서 정보
import SensorModelPage from '../pages/admin/sensor-model/SensorModelPage';
import SensorModelFormPage from '../pages/admin/sensor-model/FormPage';

//
import ErrorPage404 from '../pages/error/ErrorPage404';
import ErrorPage500 from '../pages/error/ErrorPage500';

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    // MAIN
    { element: <MainLayout />, children: [
      { index: true, element: <MainPage /> },
    ]},

    // AUTH
    { element: <AuthLayout />, children: [
      { path: 'login', element: <LoginPage /> },
      { path: 'change-password', element: <PasswordPage /> },
      { path: 'find-password', element: <FindPasswordPage /> },
      { path: 'success', element: <SuccessPage /> },
      { path: 'restrict', element: <RestrictPage /> },
      { path: 'reset-password', element: <FindPasswordPage /> },
      
      // ERROR
      { path: '/*', element: <ErrorPage404 /> },
      { path: '/alert', element: <ErrorPage500 /> }
    ]},

    { element: <Layout />, children: [
      // account
      { path: 'account', element: <LoginLogPage /> },

      // USERS
      { path: 'real-time', element: <RealTimePage /> },
      { path: 'analysis', element: <AnalysisPage /> },
      { path: 'inquiry', element: <InquiryPage /> },
      { path: 'alarm', element: <AlarmPage /> },
      { path: 'alarm-settings', element: <AlarmSettingPage /> },

      // ADMIN
      { path: 'accounts', children: [
        // 조직
        { path: 'organizations',
          children: [
            { index: true, element: <OrganizationsPage /> },
            { path: 'create', element: <OrganizationsFormPage /> },
            { path: 'update', element: <OrganizationsFormPage /> },
            // 조직 - IoT 장비 그룹
            { path: 'groups', element: <OrganizationGroupsPage /> }
          ]
        },
        // 사용자
        { path: 'members',
          children: [
            { index: true, element: <MembersPage /> },
            { path: 'create', element: <MembersFormPage /> },
            { path: 'update', element: <MembersFormPage /> }
          ]
        },
        // 로그인 조회
        { path: 'login-logs', element: <LoginLogsPage /> }
      ]},
      { path: 'iot', children: [
        // IoT 장비 현황
        { path: 'status', element: <StatusPage /> },
        // IoT 장비 그룹
        { path: 'groups',
          children: [
            { index: true, element: <GroupsPage /> },
            { path: 'create', element: <GroupsFormPage /> },
            { path: 'update', element: <GroupsFormPage /> }
          ]
        },
        // 표시명 관리
        { path: 'display-names',
          children: [
            { index: true, element: <DisplayNamesPage /> },
            { path: 'create', element: <DisplayNamesFormPage /> },
            { path: 'update', element: <DisplayNamesFormPage /> }
          ]
        },
        // IoT 장비
        { path: 'devices',
          children: [
            { index: true, element: <DevicesPage /> },
            { path: 'create', element: <DevicesFormPage /> },
            { path: 'update', element: <DevicesFormPage /> },
            // IoT 장비 - 수질 센서
            { path: 'sensors', element: <SensorsPage /> },
            // IoT 장비 - 수질 예측
            { path: 'predictions', element: <PredictionsPage /> }
          ]
        },
        // 수질 센서 모델
        { path: 'sensor-model',
          children: [
            { index: true, element: <SensorModelPage /> },
            { path: 'create', element: <SensorModelFormPage /> },
            { path: 'update', element: <SensorModelFormPage /> }
          ]
        }
      ]}
    ]}
  ]);
  return routes;
}